import React, { Component } from "react";

import {
  Wrapper,
  Title,
  Copy,
  Icon,
  Row,
  Button
} from "app/NativeComponents/common";

import { formatAddress } from "app/NativeActions";
import PropertyStatusButton from "app/DealMachineCore/snippets/PropertyItem/PropertyStatusButton";

class LeadInfoTitle extends Component {
  constructor(props) {
    super(props);

    this._property_status_button =
      props.device == "desktop" ? React.createRef() : null;
  }
  render() {
    const { conversation_info, colors, assign_new_property } = this.props;
    if (
      (conversation_info && !conversation_info.property) ||
      assign_new_property
    ) {
      return (
        <Wrapper
          style={{
            borderBottomWidth: 1,
            borderBottomStyle: "solid",
            borderBottomColor: colors.border_color,
            marginTop: this.props.isMobile
              ? this.props.isIphoneX
                ? 42
                : this.props.platform == "ios"
                ? 25
                : 12
              : 0
          }}
        >
          <Row style={{ alignItems: "flex-start" }}>
            <Wrapper style={{ flex: 1, padding: 20 }}>
              <Title>
                {assign_new_property ? "Assign To Lead" : "Reassign Lead"}
              </Title>
              <Copy style={{ fontSize: 10 }}>
                Search and select a lead below to assign this conversation.
              </Copy>
            </Wrapper>
            <Button
              onPress={this.props.handleBack}
              style={{
                width: 60,
                height: 60,
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Icon size={24} icon="close" />
            </Button>
          </Row>
        </Wrapper>
      );
    }
    if (conversation_info.property) {
      const { line1, line2 } = formatAddress({
        address: {
          address: conversation_info.property.property_address,
          address2: conversation_info.property.property_address2,
          address_city: conversation_info.property.property_address_city,
          address_state: conversation_info.property.property_address_state,
          address_zip: conversation_info.property.property_address_zip
        }
      });

      return (
        <Wrapper
          style={{
            borderBottomWidth: 1,
            borderBottomStyle: "solid",
            borderBottomColor: colors.border_color,
            marginTop: this.props.isMobile
              ? this.props.isIphoneX
                ? 42
                : this.props.platform == "ios"
                ? 25
                : 12
              : 0
          }}
        >
          <Row style={{ alignItems: "flex-start" }}>
            <Wrapper style={{ flex: 1 }}>
              <Wrapper
                style={{
                  padding: this.props.isMobile ? 20 : 10,
                  paddingBottom: 0
                }}
              >
                <Title>{line1}</Title>
                <Copy>{line2}</Copy>
              </Wrapper>
            </Wrapper>

            <Button
              onPress={this.props.handleBack}
              style={{
                width: 60,
                height: 60,
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Icon size={24} icon="close" />
            </Button>
          </Row>

          <Wrapper
            style={{
              padding: this.props.isMobile ? 10 : 0,
              paddingTop: 0
            }}
          >
            <Row>
              <Wrapper wrapper_ref={this._property_status_button}>
                <PropertyStatusButton
                  {...this.props}
                  property={conversation_info.property}
                  active_property={null}
                  _property_status_button={this._property_status_button}
                />
              </Wrapper>
              <Wrapper>
                <Button
                  style={{
                    borderWidth: 1,
                    borderColor: this.props.colors.border_color,
                    borderStyle: "solid",
                    borderRadius: this.props.isMobile ? 30 : 30,
                    padding: this.props.isMobile ? 15 : 15,
                    paddingTop: this.props.isMobile ? 10 : 5,
                    paddingBottom: this.props.isMobile ? 10 : 5,
                    margin: 15,
                    marginRight: 5,
                    marginLeft: 0,
                    backgroundColor: this.props.colors.card_color
                  }}
                  onPress={() => {
                    this.props.selectActiveProperty(
                      this.props.token,
                      conversation_info.property
                    );
                    this.props.appRedirect({
                      redirect: "property",
                      payload: {
                        property_id: conversation_info.property.property_id
                      }
                    });
                  }}
                >
                  <Copy>More Info</Copy>
                </Button>
              </Wrapper>
            </Row>
          </Wrapper>
        </Wrapper>
      );
    }
    return <Wrapper />;
  }
}

export default LeadInfoTitle;
